<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/prologue#ucu7QS845MPh3AEZE9UYx79">PROLOGUE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter1#u34rqhbuyOWS8FdemGe5uwC">CHAPTER ONE: The Unreal Dream</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter2#uGinfQseYzclKBTKTMvBX99">CHAPTER TWO: Descent Into the Deep State</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter3#uMZ7nwtsf3lSfWD76L63at2" title="Link target outside of Sample">CHAPTER THREE: The Ultimate Horror</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter4#uV3ROB4K34jBYzgZOVx6944" title="Link target outside of Sample">CHAPTER FOUR: The Knock on the Door</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter5#upMc7SoLOswGeB7FmFS3W5H" title="Link target outside of Sample">CHAPTER FIVE: HANO: High Altitude No Opening</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter6#uBtQ8hJsZFNn9zyZAqjLeuB" title="Link target outside of Sample">CHAPTER SIX: The Evidence Closes In</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter7#uQcRFYP2w9NrijRAu5deVf8" title="Link target outside of Sample">CHAPTER SEVEN: Big Brother Was Listening</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Interlude#uYwNtfJOaEAbmB5Ds2weQNH" title="Link target outside of Sample">INTERLUDE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter8#uoqHWjQ6fZjIOXroetf6yv9" title="Link target outside of Sample">CHAPTER EIGHT: The Cruelties of Fate</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Epilogue#ugzoQMYbtLQzmSoqirXxRNB" title="Link target outside of Sample">EPILOGUE: Exoneration: The Long Wait</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Photos#uNaXUoIbKRPKd5QIjBKBGFE" title="Link target outside of Sample">PHOTOS</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/AuthorsNote#uxHbrffvzcsRSO5rjOrOucG" title="Link target outside of Sample">AUTHOR’S NOTE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dedication#ubLBhKs8C3KiHRNovOafXhF" title="Link target outside of Sample">DEDICATION</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?e28147e0